export const STORE_COOKIE_NAME = 'mnpg-store'
export const STORE_COOKIE_MAX_AGE_30_DAYS = 2592000
export const MAGIC_LINK_TOKEN_HEADER_NAME = 'cst_mlt'
export const MAGIC_LINK_LOGIN_REQUIRED_PARAM_NAME = 'cst_mlt_auth_required'
